import { ArrowRight, Check } from "lucide-react";
import { Link } from "react-router-dom";

import "./pricing.css";

const starterFeatures = [
  "12 original Reel concepts",
  "18 hook, caption, or CTA variations",
  "One monthly content plan",
  "Captions and scheduling",
  "Weekly approval queue",
  "Basic performance insights",
  "One Shopify brand",
] as const;

export const PricingPage = () => (
  <main className="pricing-page">
    <header className="pricing-header">
      <a className="brand-mark" href="/" aria-label="Reelio home">
        reelio<span>.</span>
      </a>

      <nav className="pricing-header__nav" aria-label="Pricing navigation">
        <a href="/pet-product-instagram-hero.html#reel-carousel">Examples</a>
        <Link to="/auth/login">Login</Link>
      </nav>
    </header>

    <section className="pricing-content" aria-labelledby="pricing-title">
      <div className="pricing-intro">
        <h1 id="pricing-title">One plan for a consistent Instagram presence.</h1>
        <p>
          Start with the content engine. Add AI-presenter video or human editing
          only when a campaign needs it.
        </p>
      </div>

      <article className="pricing-plan">
        <div className="pricing-plan__summary">
          <div>
            <h2>Starter</h2>
            <p>Everything one Shopify brand needs to plan and approve a month.</p>
          </div>
          <p className="pricing-plan__price">
            <span>$99</span>
            /month
          </p>
        </div>

        <ul className="pricing-plan__features">
          {starterFeatures.map((feature) => (
            <li key={feature}>
              <Check size={17} strokeWidth={2.25} aria-hidden="true" />
              {feature}
            </li>
          ))}
        </ul>

        <Link className="pricing-plan__action" to="/auth/signup">
          Start creating
          <ArrowRight size={18} aria-hidden="true" />
        </Link>

        <p className="pricing-plan__note">
          AI-presenter video and human editing are metered upgrades, so the core
          subscription stays predictable.
        </p>
      </article>
    </section>
  </main>
);
